export enum PaymentMethod {
  TRANSFER = 'TRANSFER',
  BLIK = 'BLIK',
  TWISTO = 'TWISTO',
  SIMP = 'SIMP',
  CARD = 'CARD'
}
